// Details component for tag creation step
import type { SoftTagState } from '../utils/types';
import { DetailsInput } from './DetailsInput';

// Props for Details component
// handleConfirm: callback for confirming details
// handleBack: callback for going back to previous step
type DetailsProps = {
  handleConfirm: (values: any) => void;
  handleBack: () => void;
  softTagDetails: SoftTagState | null;
  isEditMode: boolean;
};

// Renders DetailsInput with provided handlers, centered in container
export const Details = ({
  handleConfirm,
  handleBack,
  softTagDetails,
  isEditMode,
}: DetailsProps) => {
  return (
    <div className="w-[50%] m-auto">
      <DetailsInput
        handleBack={handleBack}
        handleConfirm={handleConfirm}
        softTagDetails={softTagDetails}
        isEditMode={isEditMode}
      />
    </div>
  );
};
